import React from 'react';
import Page from '../components/pageScrolling';
import TitlePage from '../components/titlePages';

const AboutPage = () => {

    return (
        <>  <Page>
          
          <TitlePage titulo="Our Story."></TitlePage>   

            </Page>
        </>
    );
};

export default AboutPage;